<div bsModal #attributeModal="bs-modal" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ keyboard: false, backdrop: 'static' }">
    <div class="modal-dialog" style="width: 1000px;">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" aria-hidden="true" (click)="close()">&times;</button>
                <h3 class="modal-title" id="myModalLabel">Equipment Attributes</h3>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col-lg-6">
                        <div class="input-group">
                            <input name="NewClassification" type="text" class="form-control" placeholder="New Classification" [(ngModel)]="newClassification"/>
                            <span class="input-group-btn">
                                <button type="button" class="btn btn-info" (click)="createClassification()">Add</button>
                            </span>
                        </div>
                    </div>
                    <div class="col-lg-6">
                        <div class="input-group">
                            <input name="NewPoweredBy" type="text" class="form-control" placeholder="New Powered By" [(ngModel)]="newPoweredBy" />
                            <span class="input-group-btn">
                                <button type="button" class="btn btn-info" (click)="createPoweredBy()">Add</button>
                            </span>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-lg-6" style="height:300px; overflow-y: scroll">
                        <table class="table table-condensed table-striped">
                            <colgroup>
                                <col style="width:auto;" />
                                <col style="width:15%;" />
                                <col style="width:46px;" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>Classification</th>
                                    <th>Use Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let classification of classifications">
                                    <td>
                                        {{ classification.Name }}
                                    </td>
                                    <td>
                                        {{ classification.UseCount }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="col-lg-6" style="height:300px; overflow-y: scroll">
                        <table class="table table-condensed table-striped">
                            <colgroup>
                                <col style="width:auto;" />
                                <col style="width:15%;" />
                                <col style="width:46px;" />
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>Powered By</th>
                                    <th>Use Count</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let poweredBy of poweredBys">
                                    <td>
                                        {{ poweredBy.Name }}
                                    </td>
                                    <td>
                                        {{ poweredBy.UseCount }}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-default" (click)="close()">Close</button>
            </div>
        </div>
    </div>
</div>
